import { Component, OnInit } from '@angular/core';
import { ProductService } from 'src/app/services/product/product.service';
import { Productcategory } from 'src/app/model/productcategory.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-categorylist',
  templateUrl: './categorylist.component.html',
  styleUrls: ['./categorylist.component.css']
})
export class CategorylistComponent implements OnInit {

  data: Productcategory;

  constructor(private productServices: ProductService, private router: Router) { }

  ngOnInit() {
    this.getProductCategory();
  }

  getProductCategory() {
    this.productServices.getProductCategory().subscribe(
      (data: any) => {
        this.data = data;
        console.log(this.data);
      }
    )
  }

  deletecategory(catid: number) {
    this.productServices.deleteProductCategory(catid).subscribe(
      (data: any) => {
        if (data == true) {
          this.getProductCategory();
        }
        else
        {
          alert("Category is in use");
        }
      }
    )
  }

  editcategory(catid: number)
  {
    if(catid != null)
    {
      this.router.navigate(['/editcategory', catid]);
    }
  }


}
